export function TermsAndConditions() {
  return (
    <div className={"bg-[#E7E7E9] w-full flex-center min-h-10 lg:min-h-[70px] py-2 lg:py-4 font-jost"}>
      <a
        href={"https://cdn.botb.com/media/44xa3qe1/botb_summerleaderboard_tcs_2.pdf"}
        target={"_blank"}
        className={"text-gray-1 !underline text-center text-xs font-normal lg:text-base lg:leading-5.5"}>
        View Terms and Conditions
      </a>
    </div>
  );
}
